import day from 'dayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import LocalizedFormats from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import week from 'dayjs/plugin/weekOfYear';
import weekday from 'dayjs/plugin/weekday';

day.extend(relativeTime);
day.extend(LocalizedFormats);
day.extend(duration);
day.extend(CustomParseFormat);
day.locale('fr');
dayjs.locale('fr');
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(week);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);

export default day;
